import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { selectAuthUser } from "../features/auth/auth.slice";
import { showNotification, NotificationType } from "../app/notification-service";

interface Props {
    children?: any;
    permission?: string;
}

export default function PrivateRoute({ children, permission }: Props) {
    const user = useAppSelector(selectAuthUser);
    const location = useLocation();

    const authenticated = !!user;
    const authorized = authenticated && (!permission || user.permissions.includes(permission));

    // If not authenticated, redirect to login with current location as return URL
    if (!authenticated) {
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/account/login?returnUrl=${returnUrl}`} />;
    }

    if (!authorized) {
        showNotification(NotificationType.error, "You are not authorized to access this page.");
        return <Navigate to="/home/dashboard" />;
    }

    return children;
}
